// Copyright (c) 2016 Deere & Company

import ClaimsSettings from '../../user/claims-settings/state-connector';

export default {
    component: ClaimsSettings,
    name: 'CLAIMS_OVERVIEW',
    path: 'claims'
};



// WEBPACK FOOTER //
// ./src/routes/settings/claims.js